/*! @pentacode/ui v0.1.0 */
import { t as e } from "./styledElement-DUAqv8gi.js";
import { t } from "./reduced-motion.css-tEHc8kYn.js";
import { t as n } from "./css-build-DcREbovZ.js";
import { t as r } from "./decorateMetadata-BXz2gmG4.js";
import { t as i } from "./decorate-C_HUHFGG.js";
import { LitElement as a, html as o } from "lit";
import { customElement as s, property as c } from "lit/decorators.js";
// \0lit-plugin:css-sheet:./src/elements/assistant/assistant-avatar/assistant-avatar.css.js
var l = n(":host{display:inline-block}[part=wrapper]{width:var(--assistant-avatar-size,100%);height:var(--assistant-avatar-size,100%);border-radius:var(--assistant-chat-window-border-radius);-webkit-mask:radial-gradient(black 50%, transparent 70%) content-box 50% / var(--assistant-avatar-mask-size,150% 150%) no-repeat;mask:radial-gradient(black 50%, transparent 70%) content-box 50% / var(--assistant-avatar-mask-size,150% 150%) no-repeat;cursor:pointer;flex-shrink:0;justify-content:center;align-items:center;transition:transform .2s,width .2s,height .2s,-webkit-mask .2s,mask .2s;display:flex;overflow:hidden;-webkit-mask-composite:xor;mask-composite:exclude}[part=image]{object-fit:cover;width:100%;height:100%}"), u = class extends e(a) {
	constructor(...e) {
		super(...e), this.styles = [l, t], this.src = "";
	}
	render() {
		return o`
            <div part="wrapper">
                <img part="image" src="${this.src}" alt="Avatar" />
            </div>
        `;
	}
};
i([c({ type: String }), r("design:type", Object)], u.prototype, "src", void 0), u = i([s("ptc-ui-assistant-avatar")], u);
export { u as t };

//# sourceMappingURL=assistant-avatar-Cz6-uDf0.js.map